import React from 'react';
import { FieldError, useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import TopFieldContent from '../../../../Components/Form/components/TopFieldContent';
import ErrorMessage from '../../../../Components/Form/components/ErrorMessage';
import NCZIReferenceSearchSelect from './NCZIReferenceSearchSelect';

export interface NCZIReferenceSelectError {
	value?: {
		code?: FieldError;
	};
}

interface Props {
	label?: string;
	name: string;
	isRequired?: boolean;
	className?: string;
	oid: string;
	showCode?: boolean;
	showAbbr?: boolean;
	portal?: boolean;
}

const NCZIReferenceSearchSelectField: React.FC<Props> = ({
	name,
	label,
	className,
	isRequired,
	oid,
	showCode = false,
	showAbbr = false,
	portal,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
	});

	const referenceError = error as NCZIReferenceSelectError;

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<NCZIReferenceSearchSelect
				oid={oid}
				{...field}
				showCode={showCode}
				error={referenceError?.value?.code}
				showAbbr={showAbbr}
				portal={portal}
			/>
			{/*{referenceError?.value?.code?.message && <ErrorMessage tx={referenceError?.value?.code?.message} />}*/}
		</div>
	);
};

export default NCZIReferenceSearchSelectField;
